import Image from "@components/Image";
import styles from "./Banner.module.scss";
import cx from "classnames";
import _ from "lodash";
const View = ({
  src,
  alt = "",
  image,
  titleProps = {},
  descProps = {},
  labelProps = {},
  contentProps = {},
  title,
  description,
  label,
  searchControl,
  children,
  overlay = true,
  type = "",
  scale,
}: any) => {
  return (
    <section data-scroll-section className={cx(styles.section, styles[type])}>
      <Image
        wrapperProps={{ className: cx(styles.image) }}
        src={_.get(image, "src", "") ?? src}
        alt={_.get(image, "alt", "") ?? alt}
        layout="fill"
        objectFit="cover"
        scale={scale}
      />
      {!!overlay && <div className={styles.bgLinear}></div>}
      {!!(title || description || label) && (
        <div
          className={cx(
            "inner",
            styles.content,
            {
              [styles.contentLabel]: !!label,
            },
            contentProps.className
          )}
        >
          {!!title && (
            <h1
              {...titleProps}
              className={cx(
                "ama-section-title whitespace-pre-line",
                styles.title,
                titleProps.className
              )}
            >
              {title}
            </h1>
          )}
          {!!description && (
            <div
              {...descProps}
              className={cx(
                "ama-content whitespace-pre-line",
                styles.description,
                descProps.className
              )}
            >
              {description}
            </div>
          )}
          {!!label && (
            <div
              {...labelProps}
              className={cx(
                "ama-section-title",
                styles.label,
                labelProps.className
              )}
            >
              {label}
            </div>
          )}
          {!!searchControl && searchControl}
        </div>
      )}
      {!!children && children}
    </section>
  );
};
export default View;
